module.exports = __webpack_public_path__ + "static/media/LK__Transaction History 1.19187aef.svg";